export default "__VITE_ASSET__Dgw5Vcr6__"